





























import { Vue, Component } from 'vue-property-decorator'

const pageSize = 5

@Component({ name: 'AccountEvents' })
export default class AccountEvents extends Vue {
    private address = ''
    private items = null as Connex.Thor.Event[] | null
    private error = null as Error | null
    private loading = false
    private offset = 0

    get canNext() { return this.items && this.items.length === pageSize }
    get canPrev() { return this.items && this.offset > 0 }
    get range() {
        if (!this.loading && this.items && this.items.length > 0) {
            return [this.offset, this.offset + this.items.length]
        }
        return null
    }

    private nextPage() {
        this.offset += pageSize
        this.reload()
    }

    private prevPage() {
        if (this.offset >= pageSize) {
            this.offset -= pageSize
            this.reload()
        }
    }

    private async reload() {
        if (this.loading) {
            return
        }
        try {
            this.loading = true
            this.error = null
            this.items = await this.$connex.thor.filter('event')
                .criteria([{ address: this.address }])
                .order('desc')
                .apply(this.offset, pageSize)
        } catch (err) {
            this.error = err
        } finally {
            this.loading = false
        }
    }

    private created() {
        this.address = this.$route.params.address.toLowerCase()
        this.reload()
    }

}


